import { CalendarMonth, Send, SmsFailed } from "@mui/icons-material";
import { Badge, Box, Tab, Tabs } from "@mui/material";
import { ActionConfirmationDialog } from "../../../ScheduledMessages/ActionConfirmationDialog";
import { MessageTable } from "../../../ScheduledMessages/MessageTable";
import ScheduleTextMessageState from "../State/ScheduleTextMessageState";
import MessageHistoryTabState from "./State/MessageHistoryTabState";
import { ITabPanelProps } from "../../../../App/Typings/TabPanel";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";

function TabPanel(props: ITabPanelProps) {
  const { children, value, index, sx, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, ...sx }}>{children}</Box>}
    </div>
  );
}

function historyListProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MessageHistoryTabs({ groupId, isGroup }: { groupId?: string; isGroup?: boolean }) {
  const {
    getters: {
      receivedMessages,
      errorMessages,
      sentMessages,
      schMessages,
      tabValue,
      isLoadingScheduledMessages,
      columnsWithActionButtons,
      deleteScheduledMessageIsLoading,
      showConfirmDialog,
      actionMessage,
      columnsNoActionButtons,
    },
    handlers: { deleteSelectedScheduledMessages, handleChange, handleConfirmationResponse },
  } = MessageHistoryTabState(groupId, isGroup);

  const scheduleState = ScheduleTextMessageState();

  return (
    <>
      <Box
        sx={{ width: "100%", borderTop: 1, borderColor: "divider", paddingTop: 1 }}
        data-test="message-history-tables"
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleChange} aria-label="group message history">
            <Tab
              data-test="message-scheduled-tab"
              iconPosition="start"
              sx={{ minHeight: 0 }}
              icon={
                <Badge
                  badgeContent={schMessages.length}
                  color="primary"
                  showZero={false}
                  max={999}
                  data-test="message-scheduled-badge"
                >
                  <CalendarMonth />
                </Badge>
              }
              label={"Scheduled"}
              {...historyListProps(0)}
            />
            <Tab
              data-test="message-sent-tab"
              iconPosition="start"
              sx={{ minHeight: 0 }}
              icon={
                <Badge
                  badgeContent={sentMessages.length}
                  color="primary"
                  showZero={false}
                  max={999}
                  data-test="message-sent-badge"
                >
                  <Send />
                </Badge>
              }
              label={"Sent"}
              {...historyListProps(1)}
            />
            <Tab
              data-test="message-received-tab"
              iconPosition="start"
              sx={{ minHeight: 0 }}
              icon={
                <Badge
                  badgeContent={receivedMessages.length}
                  color="primary"
                  showZero={false}
                  max={999}
                  data-test="message-received-badge"
                >
                  <MoveToInboxIcon />
                </Badge>
              }
              label={"Received"}
              {...historyListProps(2)}
            />
            <Tab
              data-test="message-exception-tab"
              iconPosition="start"
              sx={{ minHeight: 0 }}
              icon={
                <Badge
                  badgeContent={errorMessages.length}
                  color="error"
                  showZero={false}
                  max={999}
                  data-test="message-exception-badge"
                >
                  <SmsFailed />
                </Badge>
              }
              label={"Exceptions"}
              {...historyListProps(3)}
            />
          </Tabs>
        </Box>
        <TabPanel value={tabValue} index={0} sx={{ paddingBottom: 0 }}>
          <MessageTable
            id={"scheduled-message-tbl"}
            loading={isLoadingScheduledMessages}
            columns={columnsWithActionButtons}
            tableData={schMessages}
            isEditingGroup={false}
            deleteSelectedScheduledMessages={deleteSelectedScheduledMessages}
            showActions={true}
            disableDeleteButton={deleteScheduledMessageIsLoading}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={1} sx={{ paddingBottom: 0 }}>
          <MessageTable
            id={"sent-message-tbl"}
            loading={isLoadingScheduledMessages}
            columns={columnsNoActionButtons}
            tableData={sentMessages}
            isEditingGroup={false}
            deleteSelectedScheduledMessages={deleteSelectedScheduledMessages}
            showActions={false}
            disableDeleteButton={deleteScheduledMessageIsLoading}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={2} sx={{ paddingBottom: 0 }}>
          <MessageTable
            id={"received-message-tbl"}
            loading={isLoadingScheduledMessages}
            columns={columnsNoActionButtons}
            tableData={receivedMessages}
            isEditingGroup={false}
            deleteSelectedScheduledMessages={deleteSelectedScheduledMessages}
            showActions={false}
            disableDeleteButton={deleteScheduledMessageIsLoading}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={3} sx={{ paddingBottom: 0 }}>
          <MessageTable
            id={"error-message-tbl"}
            loading={isLoadingScheduledMessages}
            columns={columnsNoActionButtons}
            tableData={errorMessages}
            isEditingGroup={false}
            deleteSelectedScheduledMessages={deleteSelectedScheduledMessages}
            showActions={false}
            disableDeleteButton={deleteScheduledMessageIsLoading}
          />
        </TabPanel>
        <ActionConfirmationDialog
          handleClose={handleConfirmationResponse}
          open={showConfirmDialog}
          message={actionMessage}
        />
      </Box>
      <ActionConfirmationDialog
        handleClose={scheduleState.handlers.handleConfirmationResponse}
        open={scheduleState.getters.showConfirmDialog}
        message={scheduleState.getters.actionMessage}
      />
    </>
  );
}
